import React from 'react'
import PropTypes from 'prop-types'
import { isString } from 'utils/types'
import StyledChecTable from './ChecTable.styles'
import 'styles/AntOverrides.css'

const ChecTable = (props) => {
  const {
    dataSource,
    className,
    rowClassName,
    columns,
    yScroll,
    xScroll,
    pagination,
    onRow,
    size,
    rowKey,
    bordered,
    rowSelection,
    title,
  } = props

  const scroll = {}
  if (yScroll) scroll.y = yScroll
  if (xScroll) scroll.x = xScroll

  const rowClass = isString(rowClassName)
    ? `chec-table-row ${rowClassName}`
    : (record, index) => `chec-table-row ${rowClassName(record, index)}`

  return (
    <>
      {title && <h2>{title}</h2>}
      <StyledChecTable
        rowSelection={rowSelection}
        bordered={bordered}
        pagination={pagination}
        onRow={onRow}
        size={size}
        rowKey={rowKey}
        className={`chec-table ${className}`}
        dataSource={dataSource}
        columns={columns}
        scroll={scroll}
        rowClassName={rowClass}
      />
    </>
  )
}

ChecTable.defaultProps = {
  className: '',
  rowClassName: '',
  size: 'default',
  pagination: false,
  title: null,
}

ChecTable.propTypes = {
  bordered: PropTypes.bool,
  rowSelection: PropTypes.object,
  rowClassName: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  className: PropTypes.string,
  dataSource: PropTypes.arrayOf(PropTypes.object).isRequired,
  // TODO define column object shape
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  yScroll: PropTypes.number,
  xScroll: PropTypes.number,
  pagination: PropTypes.bool,
  onRow: PropTypes.func,
  size: PropTypes.string,
  rowKey: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
}

export default ChecTable
